import { createContext, useContext, useMemo } from 'react';
import { setupTracker } from 'framework-listing-lib/utils/tracker';
import { jsx as _jsx } from "react/jsx-runtime";
const TrackerContext = /*#__PURE__*/createContext(undefined);
export default function TrackerProvider({
  applicationId,
  children,
  onTrackEvent,
  tracker
}) {
  const value = useMemo(() => {
    const trackerInstance = setupTracker(tracker);
    return {
      applicationId,
      onTrackEvent,
      track: trackerInstance === null || trackerInstance === void 0 ? void 0 : trackerInstance.track.bind(trackerInstance),
      consumerTracker: tracker
    };
  }, [applicationId, onTrackEvent, tracker]);
  return /*#__PURE__*/_jsx(TrackerContext.Provider, {
    value: value,
    children: children
  });
}
export function useTracker() {
  const context = useContext(TrackerContext);
  if (context === undefined) {
    throw new Error('useTracker must be used within a TrackerProvider');
  }
  return context;
}